import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";

// import { GridHEading, GridImage, ReadMore, CharityImage } from "./Styles";
import arbvideo from "../../../assets/images/arbvideo.mp4"
import { P, SectionSubHeading, SectionWrapper } from "../../Styles/style";
import { ReadMore } from "../S1_Header/styles";
import readmore from "../../../assets/images/readmore.png"
const AboutImage = styled.img`
  width: 100%;
  height: auto;
  /* max-width: 80%; */
`;
const VideoBK = styled.video`
  object-fit: cover;
  width: 100%;
  max-width: 100%;
  height: auto;
`; const GridHEading = styled(Grid)`
padding: 50px 0;
/* align-items: center;
place-content: ${(props) => (props.pc ? props.pc : "")}; */
`;
const GridImage = styled(Grid)`
padding: 50px 0;
/* place-content: ${(props) => (props.pc ? props.pc : "center")};
text-align: center; */
text-align: left;
`;
const JOiningLinks = styled.img`
  width: 100%;
  max-width: ${(props) => (props.mw ? props.mw : "180PX")};
  @media screen and (max-width:599px){
   max-width: ${(props) => (props.mw ? props.mw : "140PX")};

 }
`
const S2_Aboutus = () => {
  return (
    <div>
      <SectionWrapper p="2rem 0" id="about">
        <Container maxWidth="xl">
          {" "}
          
          <GridHEading container >

            <GridImage xs={12} md={6}>
            <SectionSubHeading
            p="30px 0"
            m="0"
            data-aos="fade-zoom-in"
            data-aos-easing="ease-in"
            data-aos-delay="400"
            data-aos-duration="400"
            data-aos-offset="0"
          >
            About
          </SectionSubHeading>
              <P
                // maxWidth="90%"
                p="0 0 40px 0"
                m="0"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="600"
                data-aos-duration="600"
                data-aos-offset="0"
              >
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.

                <br />
                <br />

                At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet
              </P>
              <a data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="700"
                data-aos-duration="700"
                data-aos-offset="0"
                href="/"
                target="_blank">
                <JOiningLinks src={readmore} />
              </a>
            
            </GridImage>
            <Grid
              xs={12}
              md={6}
              data-aos="fade-zoom-in"
              data-aos-easing="ease-in"
              data-aos-delay="500"
              data-aos-duration="500"
              data-aos-offset="0"
            >
              <VideoBK autoPlay loop muted>
                <source src={arbvideo} type="video/mp4" />
              </VideoBK>
            </Grid>
          </GridHEading>
        </Container>
      </SectionWrapper>
    </div>
  );
};

export default S2_Aboutus;
